import { Box, Grid } from "@mui/material";
import { Container } from "@mui/system";
import React, { useEffect, useState } from "react";
import {
  PrimaryButton,
  SecondaryButton,
  LinkButton,
} from "../../../common/Buttons";
import { getStatusQuo, postStatusQuo } from "../../../services/yourWishes";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../../common/Checkbox";
import { Circles } from "react-loader-spinner";
import {
  getKeyFromText,
  getUserIdFromLocalStorage,
} from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const StatusQuo = ({ next, pre }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [statusQuoListing, setStatusQuoListing] = useState([]);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  let uID = getUserIdFromLocalStorage();

  useEffect(() => {
    getAllStatusQuo();
  }, []);

  const getAllStatusQuo = async () => {
    const result = await getStatusQuo(uID);
    if (result?.success) {
      setStatusQuoListing(result.payLoad);
    }
  };
  const handleClickOnItem = (statusQuoId) => {
    setStatusQuoListing(
      statusQuoListing.map((ele) => {
        if (ele.statusQuoId == statusQuoId) {
          return {
            ...ele,
            isStatusQuoChecked: !ele.isStatusQuoChecked,
          };
        }
        return ele;
      })
    );
  };
  const postStatusQuoListing = async (values) => {
    const arr = [];
    if (values) {
      statusQuoListing.map(function ({
        statusQuoId,
        isStatusQuoChecked,
        isWishChecked,
      }) {
        return arr.push({ statusQuoId, isStatusQuoChecked, isWishChecked });
      });
    }
    return await postStatusQuo(
      arr.map((item) => {
        if (item.isStatusQuoChecked && item.isWishChecked) {
          return {
            statusQuoId: item.statusQuoId,
            isStatusQuoChecked: true,
            isWishChecked: item.isWishChecked,
          };
        }
        return item;
      }),
      uID
    );
  };
  const handleSubmit = async (values = true) => {
    setButtonDisabled(true);
    const result = await postStatusQuoListing(values);
    if (result?.success) {
      if (statusQuoListing.filter((item) => item.isStatusQuoChecked)?.length) {
        next();
      } else {
        navigate("/your-wishes/your-wishes");
      }
    }
    setButtonDisabled(false);
  };
  const handleSkip = () => {
    if (statusQuoListing.filter((item) => item.isStatusQuoChecked)?.length) {
      next();
    } else {
      navigate("/your-wishes/your-wishes");
    }
  };
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="75vh"
    >
      <Box display="flex" flexDirection="column" alignItems="center">
        <h1 style={{ color: "#262B3E" }}>{t("sidebar-2-text-1")}</h1>
        <Grid
          container
          spacing={2}
          direction="row"
          justifyContent="center"
          alignItems="center"
          marginTop="30px"
        >
          {statusQuoListing.length == 0 ? (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Circles color="#dfc8db" height={80} width={80} />
            </Box>
          ) : (
            statusQuoListing?.map((item, index) => (
              <>
                <Grid item xs={3} />

                <Grid item xs={5}>
                  <p>{t(getKeyFromText(item.description))}</p>
                </Grid>
                <Grid item xs={2}>
                  <Checkbox
                    name="areaLT200ms"
                    id={item.id}
                    value={item.isStatusQuoChecked}
                    checked={item.isStatusQuoChecked}
                    onChange={() => handleClickOnItem(item.statusQuoId)}
                  />
                </Grid>
                <Grid item xs={2} />
              </>
            ))
          )}
        </Grid>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <SecondaryButton
          title={t("back")}
          bgColor="color.transparent"
          borderRadius="14px"
          width={i18next.language == "de" ? "150px" : "180px"}
          marginLeft="20px"
          border="1px solid #dfc8db"
          hoverBgColor="color.magentaLight1"
          click={() => {
            navigate("/");
          }}
          textTransform="initial"
          padding="0rem"
          height="2.7rem"
        />
        <SecondaryButton
          title={t("save-and-continue")}
          bgColor="#E8D7E5"
          borderRadius="14px"
          width={i18next.language == "de" ? "200px" : "180px"}
          marginLeft="10px"
          border="none"
          hoverBgColor="color.magentaLight1"
          click={handleSubmit}
          textTransform="initial"
          padding="0rem"
          height="2.7rem"
          disabled={buttonDisabled}
        />
        <LinkButton
          title={t("skip-for-now")}
          bgColor="color.transparent"
          borderRadius="14px"
          fontSize="0.8rem"
          width="100px"
          marginLeft="10px"
          border="none"
          padding="0"
          click={() => {
            handleSkip();
          }}
          textTransform="initial"
        />
      </Box>
    </Box>
  );
};

export default StatusQuo;
